/* eslint-disable no-shadow */
/*
 *
 * PaymentLinks reducer
 *
 */
import produce from 'immer';
import {
  DEFAULT_PG_MENU_TAB_STATE,
  DEFAULT_CURRENT_PAGE,
} from 'utils/constants';

import {
  DEFAULT_ACTION,
  SET_ACTIVE_NAVIGATION,
  HEADINGS,
  ENABLE_LOADER,
  DISABLE_LOADER,
  ALL_CTA,
  BATCH_CTA,
  SAVE_VENDORS,
  UPDATE_TABLE_DATA,
  UPDATE_FILTERS,
  RESET_FILTERS,
  BATCH_UPLOAD_SAVE_RESPONSE,
  RESET_BATCH_UPLOAD_RESPONSE,
  CREATE_VENDOR_SAVE_RESPONSE,
  UPDATE_VENDOR_SAVE_RESPONSE,
  SAVE_SETTLEMENT_CONFIG,
  SAVE_VENDOR_DATA_BY_ID,
  RESET_VENDOR_DATA_BY_ID,
  RESET_PAGE,
  RESET_DATA,
  SAVE_VENDOR_DOCS,
} from './constants';

const {
  filters: { appliedFilters, dateFilters, ...f },
  ...rest
} = DEFAULT_PG_MENU_TAB_STATE;

const getInitialState = () => ({
  activeNavigation: 'EASY_SPLIT_ALL',
  isLoading: false,
  vendorOdEnabled: true,
  headingData: HEADINGS.EASY_SPLIT_ALL,
  tabs: {
    EASY_SPLIT_ALL: {
      ...rest,
      filters: {
        ...f,
        appliedFilters: {},
      },
      buttonContent: 'Add Vendor',
      buttonCTAModal: ALL_CTA,
      vendorDocs: {},
    },
    EASY_SPLIT_BATCH: {
      ...rest,
      filters: {
        ...f,
      },
      buttonContent: 'Upload File',
      buttonCTAModal: BATCH_CTA,
      linkContent: {
        url: 'https://cashfreelogo.cashfree.com//easy-split/sample-easy-split-v3.csv',
        text: 'Download Sample File',
      },
    },
  },
  batchUploadResponse: {},
});

export const initialState = {
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const easySplitReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SAVE_VENDORS: {
        const { data, activeNavigation } = action.payload;
        draft.tabs[activeNavigation].data =
          data && data.content ? data.content : [];
        draft.activeNavigation = activeNavigation;
        draft.isLoading = false;
        break;
      }
      case UPDATE_TABLE_DATA: {
        const {
          totalCount,
          hasPrevEnabled,
          hasNextEnabled,
          currentPageRowData,
        } = action.data;
        draft.tabs[draft.activeNavigation].totalCount = totalCount;
        draft.tabs[draft.activeNavigation].hasPrev = hasPrevEnabled;
        draft.tabs[draft.activeNavigation].hasNext = hasNextEnabled;
        draft.tabs[
          draft.activeNavigation
        ].currentPageRowData = currentPageRowData;
        break;
      }
      case SET_ACTIVE_NAVIGATION: {
        draft.activeNavigation = action.data;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case UPDATE_FILTERS: {
        const {
          appliedFilters,
          dateFilters,
          filtersForDisplay,
          ...filters
        } = action.data;
        if (appliedFilters) {
          const { startDate, endDate, ...rest } = appliedFilters;
          draft.tabs[draft.activeNavigation].filters.appliedFilters = rest;
        }
        if (dateFilters)
          draft.tabs[draft.activeNavigation].filters.dateFilters = dateFilters;
        draft.tabs[draft.activeNavigation].filters = {
          ...draft.tabs[draft.activeNavigation].filters,
          ...filters,
        };
        if (filtersForDisplay) {
          draft.tabs[
            draft.activeNavigation
          ].filtersForDisplay = filtersForDisplay;
        }
        break;
      }
      case RESET_FILTERS: {
        draft.tabs[draft.activeNavigation].filters.appliedFilters =
          initialState.tabs[draft.activeNavigation].filters.appliedFilters;

        draft.tabs[draft.activeNavigation].filtersForDisplay =
          initialState.tabs[draft.activeNavigation].filtersForDisplay;
        break;
      }
      case BATCH_UPLOAD_SAVE_RESPONSE: {
        const batchUploadResponse = { ...action.data };
        batchUploadResponse.isFileUploadSuccessful =
          action.data && !action.data.status;
        if (!batchUploadResponse.failedCreateBatchVendors) {
          batchUploadResponse.failedCreateBatchVendors = [];
        }
        draft.batchUploadResponse = batchUploadResponse;
        break;
      }
      case RESET_BATCH_UPLOAD_RESPONSE: {
        draft.batchUploadResponse = {};
        break;
      }
      case CREATE_VENDOR_SAVE_RESPONSE: {
        if (action.response) {
          const obj = { ...action.response, balance: 0 };
          draft.tabs[draft.activeNavigation].data.unshift(obj);
        }
        break;
      }

      case UPDATE_VENDOR_SAVE_RESPONSE: {
        if (action.response) {
          const resultant = { ...action.response };
          const index =
            draft.tabs[draft.activeNavigation].data &&
            draft.tabs[draft.activeNavigation].data.findIndex(
              obj => obj.merchantVendorId === resultant.merchantVendorId,
            );
          if (index !== -1) {
            const obj = {
              ...draft.tabs[draft.activeNavigation].data[index],
              ...resultant,
            };
            draft.tabs[draft.activeNavigation].data[index] = obj;
          }
        }
        break;
      }
      case RESET_PAGE:
        draft.tabs[
          draft.activeNavigation
        ].filters.pageNo = DEFAULT_CURRENT_PAGE;
        break;
      case SAVE_SETTLEMENT_CONFIG: {
        const { settlementConfig, vendorOdConfig } = action.data;
        if (settlementConfig)
          draft.schedules = settlementConfig.availableSchedules;
        if (vendorOdConfig)
          draft.vendorOdEnabled = vendorOdConfig.onDemandEnabled;

        break;
      }
      case SAVE_VENDOR_DATA_BY_ID: {
        draft.vendorIdData = action.data;
        break;
      }
      case RESET_VENDOR_DATA_BY_ID: {
        draft.vendorIdData = {};
        break;
      }
      case RESET_DATA: {
        const obj = getInitialState();
        Object.keys(obj).forEach(k => (draft[k] = obj[k])); // eslint-disable-line
        break;
      }
      case SAVE_VENDOR_DOCS: {
        draft.tabs.EASY_SPLIT_ALL.vendorDocs = action.data;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default easySplitReducer;
